<template>
  <div class="control">
    <div class="sub animated" :class="{slideOutLeft:isOpenDetail,slideInLeft:!isOpenDetail&&isAnimate}" v-if="!isOpenDetail">
      <subfield :switchNav="switchNav" :listIsShow="listShow" @listIsShow="closeGroup">
        <template slot="list">
          <trees type="GROUP" @getAssets="getAssets" :list="groupList" :showCheckbox="true"></trees>
        </template>
        <template slot="content">
          <enfold-ucd class="eu-content">
            <template slot="up">
              <div class="cu0">
                <div class="isonline">
                  <div class="online_div">
                    <div class="online_div_small"></div>
                  </div>
                  <span class="online">{{ `${$t('terminal.online')}-${online}` }}</span>
                  <div class="online_divr" style="margin-left: 15px;">
                    <div class="online_div_smallr"></div>
                  </div>
                  <span class="offline">{{ `${$t('terminal.offline')}-${offline}` }}</span>
                  <span class="detail" style="margin-left: 15px;" @click="openDetailDialog">{{$t('terminal.Details')}}</span>
                </div>
                <div class="up-right">
                  <div class="testDiv" @click="testCommand"></div>
                  <popovers :content="$t('terminal.list')">
                    <i class="icon" @click="changeCurretModel('list')">
                      <img v-if="this.currentModel == 'list'" class="icon" src="@/assets/images/public/public_list_sel.png" />
                      <img v-else class="icon" src="@/assets/images/public/public_list_nor.png" />
                    </i>
                  </popovers>
                  <popovers :content="$t('terminal.card')">
                    <i class="icon" @click="changeCurretModel('card')" style="margin-right: 0;">
                      <img v-if="this.currentModel == 'card'" class="icon" src="@/assets/images/public/public_chart_sel.png" />
                      <img v-else class="icon" src="@/assets/images/public/public_chart_nor.png" />
                    </i>
                  </popovers>
                  <el-button @click="changeCurretModel('map')" size="mini" round type="primary">{{$t('terminal.map')}}</el-button>
                  <!-- <el-button @click='testMap'>测试</el-button> -->
                </div>
              </div>
              <div class="cu1">
                <div class="up-left">
                  <i class="icon" @click="openBt">
                    <img class="icon deg" :class="{ deg90: !btstyle }" src="@imgpub/public_closearrow.png" />
                  </i>
                  <div class="search">
                    <div class="search_input">
                      <el-input v-model="search_data" size="mini" :placeholder="$t('terminal.keyWord')">
                        <i slot="suffix" class="el-icon-search" @click="search"></i>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="cu1_right" v-show="currentModel!='map'">
                  <!-- <el-upload action :http-request="getExcel" :show-file-list="false" style="display: inline-block;margin-right: 10px;background-color: transparent;">
                    <el-button type="primary" round size="mini" style="display: inline-block;height: 30px;">{{$t('terminal.batchAdd')}}</el-button>
                  </el-upload> -->
                  <el-button type="primary" @click="addDeviceList" round size="mini">{{$t('terminal.batchAdd')}}</el-button>
                  <el-button type="primary" @click="refreshTerminal" round size="mini">{{$t('terminal.refresh')}}</el-button>
                  <el-button type="primary" @click="addDevice" round size="mini">{{$t('terminal.add')}}</el-button>
                  <el-button type="danger" @click="multipleDelete" round size="mini">{{$t('terminal.delete')}}</el-button>
                </div>
              </div>
              <div class="cu2" :class="{ cu2Style0: btstyle }">

                <!-- <handle-order v-for="item in OrderGroup" :btType="item.btType" :orderName="$t(`${item.orderName}`)" :orderType="item.orderType" :isList="isList" :panduan="panduan" :itemPanduan="itemPanduan" :noCheckList="noCheckList" :itemsNoselectList="itemsNoselectList" :listSeletList="listSeletList" :currentItem="currentItem" :current="current" :itemsDataList="itemsDataList" :key="item.orderType" @orderBack="orderBack" style="flex: none;margin: 0 6px;"></handle-order> -->
                <handle-order v-for="item in OrderGroup" :btType="item.btType" :orderName="$t(`${item.orderName}`)" :orderType="item.orderType" :isList="isList" :panduan="panduan" :itemPanduan="itemPanduan" :noCheckList="noCheckList" :itemsNoselectList="itemsNoselectList" :listSeletList="listSeletList" :currentItem="currentItem" :current="current" :itemsDataList="itemsDataList" :key="item.orderType" @orderBack="orderBack" style="flex: none;margin: 0 6px;" v-show="!item.isFold"></handle-order>

                <el-dropdown style="flex: none;margin: 0 6px;" v-if="OrderGroup.filter(og=>og.isFold).length">
                  <el-button type="primary" size="mini" round>
                    {{$t('ssdcbl5')}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in OrderGroup" :key="item.orderType">
                      <handle-order :btType="item.btType" :orderName="$t(`${item.orderName}`)" :orderType="item.orderType" :isList="isList" :panduan="panduan" :itemPanduan="itemPanduan" :noCheckList="noCheckList" :itemsNoselectList="itemsNoselectList" :listSeletList="listSeletList" :currentItem="currentItem" :current="current" :itemsDataList="itemsDataList" @orderBack="orderBack" style="flex: none;margin: 0 6px;" v-show="item.isFold"></handle-order>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot="center">
              <template v-if="currentModel=='list'">
                <el-table :data="terminalList" style="width: 100%" height="100%" :highlight-current-row="true" @selection-change="selectionLineChangeHandle" :row-key="getRowKey" v-loading="loading" ref="multipleTable" @row-click="openDetail">
                  <el-table-column type="selection" :reserve-selection="true"></el-table-column>
                  <el-table-column prop="name" :label="$t('terminal.deviceName')"></el-table-column>
                  <el-table-column prop="remark1" :label="$t('terminal.remark')"></el-table-column>
                  <el-table-column prop="size_remark" :label="$t('terminal.resolution')"></el-table-column>
                  <el-table-column prop="type_remark" :label="$t('terminal.types')">
                    <template slot-scope="scope">
                      {{deviceType[scope.row.type_remark] }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="system_version" :label="$t('terminal.version')">
                    <template slot-scope="scope">
                      <span v-if="scope.row.system_version != null && scope.row.type_remark!='Kommander' &&scope.row.system_version.length!=0">{{`v${scope.row.system_version}`}}</span>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="run_state" :label="$t('terminal.status')" min-width="80px">
                    <template slot-scope="scope">
                      <span :style="'color:' + scope.row.runStateInfo.stateColor">{{ $t(scope.row.runStateInfo.stateName) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('terminal.operate')">
                    <template slot-scope="scope">
                      <div class="operation">
                        <!-- <el-tooltip effect="dark" content="上移" placement="top-start">
                          <img class="icon" :style="{cursor:scope.$index?'pointer':'not-allowed'}" src="@/assets/images/release/list_up.png" @click.stop="handleSort(scope.$index,scope.row.id)" />
                        </el-tooltip> -->
                        <img class="icon" :style="{cursor:scope.$index?'pointer':'not-allowed'}" src="@/assets/images/release/list_up.png" @click.stop="handleSort(scope.$index,scope.row.id)" />
                        <el-tooltip effect="dark" :content="$t('terminal.edit')" placement="top-start">
                          <img class="icon" src="@/assets/images/public/public_edit.png" @click.stop="handleEdit(scope.row)" />
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('terminal.Details')" placement="top-start">
                          <img class="icon" src="@/assets/images/public/public_detail.png" @click.stop="handleDetail(scope.row)" />
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('terminal.delete')" placement="top-start">
                          <img class="icon" src="@/assets/images/public/public_delete.png" @click.stop="handleDelete(scope.row)" />
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <template v-if="currentModel=='card'">
                <div class="card" id="card" v-loading="loading">
                  <!-- <template v-for="item in itemsData"> -->
                  <terminal-item :device="item" v-for="item in itemsData" :key="item.id" class="items">
                    <div v-loading="item.imgloading" :element-loading-text="$t('terminal.loading')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%;height: 100%;" slot="img">
                      <template v-if="currentDetail.system_version && currentDetail.system_version.split('-')[1] < 299">
                        <img src :data-src="'/upload/capture/d_' + item.id + '/' + 'device_' + item.id + '_capture.png?t=' + new Date().getTime()" class="itemsimg pdtop" />
                      </template>
                      <template v-else>
                        <img src :data-src="'/upload/capture/d_' + item.id + '/' + 'device_' + item.id + '_capture.png?t=' + new Date().getTime()" :device-id="item.id" class="itemsimgHight pdtop" />
                      </template>
                    </div>
                    <el-checkbox v-model="item.isChecked" @change="checkedItem(item)" @click="selectItem" slot="check" class="check" :class="{ckecked:itemsDataList.length!=0}"></el-checkbox>
                  </terminal-item>
                  <!-- </template> -->
                  <div class="itemsblock"></div>
                  <div class="itemsblock"></div>
                  <div class="itemsblock"></div>
                  <div class="itemsblock"></div>
                </div>
              </template>
              <template v-if="currentModel=='map'">
                <device-map :deviceList="devicelist" v-if="isDeviceLoaded" @seleceDevice="seleceDevice" @showAddress="showAddress"></device-map>
              </template>
            </template>
            <template slot="down">
              <div class="down" v-if="currentModel=='list'">
                <el-checkbox v-model="checked" :indeterminate="isIndeterminate" style="margin-left: 20px;" :disabled="this.terminalList.length == 0" @change="selectAll">{{$t('terminal.allSelect')}}</el-checkbox>
                <span style="margin-left: 20px" v-if="this.panduan == true">{{$t('terminal.selected')}}{{ this.current - this.noCheckList.length }}</span>
                <span style="margin-left: 20px" v-else>{{$t('terminal.selected')}}{{ this.listSeletList.length }}</span>
                <pagination :current="current" :limit="limit" :currentPage="this.currentPage" :page="this.page" @currentChange="currentChange" class="pagina"></pagination>
                <order-feed-back :feedback="feedback" class="feedback"></order-feed-back>
              </div>
              <div class="down" v-if="currentModel=='card'">
                <el-checkbox v-model="itemChecked" @change="itemSelectAll" style="margin-left: 20px;" :indeterminate="itemCurrentPageIsIndeterminate" :disabled="this.itemsData.length == 0">{{$t('terminal.selectAll')}}</el-checkbox>
                <el-checkbox v-model="itemAllChecked" @change="itemSelectAllPage" :disabled="this.itemsData.length == 0" :indeterminate="itemAllPageIsIndeterminate" class="allselect">{{$t('terminal.allSelect')}}</el-checkbox>
                <span style="margin-left: 10px" v-if="this.itemAllChecked == false">{{$t('terminal.selected')}}{{ this.itemsDataList.length }}</span>
                <span style="margin-left: 10px" v-else>{{$t('terminal.selected')}}{{this.current - this.itemsNoselectList.length}}</span>
                <el-pagination align="center" @current-change="currentChangeItem" :current-page="this.itemCurrentPage" :page-sizes="[this.itemLimit]" :page-size="this.itemLimit" background layout="prev,pager,next" :total="currentItem" class="pagina" v-show="currentItem>12"></el-pagination>
                <order-feed-back :feedback="feedback" class="feedback"></order-feed-back>
              </div>
              <div class="down" v-if="currentModel=='map'">
                <div class="pagina">
                  <template v-if="Address.add==''">
                    <span>{{$t('terminal.selectInMap')}}</span>
                  </template>
                  <template v-else>
                    <div class="flex-d-c-c">
                      <span>{{Address.add}}</span>
                      <span>{{`[${Number(Address.pos[0])},${Number(Address.pos[1])}]`}}</span>
                    </div>
                  </template>
                </div>
                <order-feed-back :feedback="feedback" class="feedback"></order-feed-back>
              </div>
            </template>
          </enfold-ucd>
        </template>
        <template slot="details">
          <div class="details">
            <div class="left">
              <img class="closeicon" @click="closeDetail" src="@/assets/images/public/public_closeorg.png" alt />
            </div>
            <div class="right">
              <device-detail :currentDetail="currentDetail" v-if="isDetail&&currentModel=='list'&&currentDetailVsersion <260"></device-detail>

              <device-detail-hight :currentDetail="currentDetail" :key="currentDetail.id" v-if="isDetail&&currentModel=='list' && currentDetailVsersion>=260"></device-detail-hight>
            </div>
          </div>
        </template>
      </subfield>
    </div>
    <template>
      <div class="rightDetail animated" :class="{slideInRight:isOpenDetail,slideOutRight:!isOpenDetail}" v-if="isOpenDetail">
        <device-detail-open :currentDetail="currentDetail" @closeOpenDetail="closeOpenDetail"></device-detail-open>
      </div>
    </template>
    <form-dialog :dialogVisible="deviceDialogVisible" @closeDialog="deviceFormDiaoClose" dWidth="860px" :title="$t('terminal.addDevice')">
      <div class="flex-c-s">
        <div class="form" :class="{formClose:isBigMap}" v-if="!isBigMap">
          <el-form label-width="auto" :rules="rules" :model="form" ref="userForm" v-loading="loading">
            <el-form-item :label="$t('terminal.deviceName')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('terminal.structure')" prop="group_id">
              <el-select v-model="form.group_id" :placeholder="$t('terminal.selectGroup')" style="width: 100%;">
                <el-option v-for="(item, index) in groupIdLabel" :key="index" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('terminal.resolution')" v-if="form.size_id !=='-1'" prop="size_id">
              <!-- 选择分辨率 -->
              <el-select v-model="form.size_id" :placeholder="$t('terminal.selectSize')" style="width: 100%;">
                <el-option :label="$t('terminal.customize')" value="-1"></el-option>
                <el-option v-for="(item, index) in configList.size" :key="index" :label="item.resolution" :value="item.resolution" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('terminal.resolution')" v-if="form.size_id =='-1'" required prop="size_id">
              <div class="input-label" v-if="form.size_id =='-1'">
                <el-form-item prop="w">
                  <el-input-number :controls="false" placeholder="W" :min="20" v-model="form.w" style="width: 110px;"></el-input-number>
                </el-form-item>
                <el-form-item prop="h">
                  <el-input-number :controls="false" placeholder="H" :min="20" v-model="form.h" style="width: 110px;"></el-input-number>
                </el-form-item>
                <div>
                  <el-button icon="el-icon-close" circle size="mini" @click="changeSizeList"></el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('terminal.deviceType')" prop="type">
              <el-select v-model="form.type_id" :placeholder="$t('terminal.deviceTypeTip')" :disabled="this.ADDEDIT === 'EDIT'" style="width: 100%;" @change="changeRule">
                <el-option v-for="(item, index) in configList.type" :key="index" :label="item.remark_zh" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="SN" prop="sn">
              <div class="input-label">
                <el-input placeholder="SN" v-model="form.sn" :disabled="this.ADDEDIT === 'EDIT'"></el-input>
              </div>
            </el-form-item>
            <el-form-item :label="$t('terminal.key')" v-if="form.type_id === '1'" prop="secret">
              <el-input v-model="form.secret"></el-input>
            </el-form-item>
            <el-form-item :label="$t('terminal.remark')" prop="remark1">
              <el-input v-model="form.remark1"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ctco1')">
              <el-date-picker style="width:100%" :clearable="false" v-model="form.installation" type="datetime" :placeholder="$t('ctco2')">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="map" :class="{bigMap:isBigMap}">
          <!-- <amap-single :formDialog="form" :dialogTitle="ADDEDIT" @amapData="amapData">
          </amap-single>-->
          <img src="@/assets/images/public/public_closeorg.png" class="controlMap" :class="{controlMapRight:isBigMap}" @click="controlMap" />
          <device-map v-if="showMap&&isLoadSingleDevice" :deviceName="this.form.name" :form="this.form" :isDetail="false" :isAddDevice="ADDEDIT" @amapData="amapData"></device-map>
        </div>
      </div>
      <div style="width: 100%;text-align: center; margin-top: 10px;">
        <el-button round @click="cancel">{{$t('terminal.cancel')}}</el-button>
        <el-button round type="primary" @click="submitForm">{{$t('terminal.confirm')}}</el-button>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="MulDelDialogVisible" @closeDialog="MulDelDialog" :title="$t('terminal.delDevice')">
      <div class="dd-dialog">{{$t('terminal.delDevTip')}}</div>
    </del-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('terminal.delDevice')">
      <div class="dd-dialog">{{$t('terminal.delDevTip')}}</div>
    </del-dialog>
    <form-dialog :title="$t('terminal.onlineTotal')" :dialogVisible="detailDialog" @closeDialog="detailCloseDialog" dWidth="650px">
      <online-detail v-if="isDetailOnline"></online-detail>
    </form-dialog>
    <form-dialog :title="$t('ctco3')" :dialogVisible="testDialog" @closeDialog="testClose" dWidth="450px">
      <div class="flex-d-b-c" style="height: 300px;">
        <div style="width: 100%;">
          <el-input v-model="testInput" placeholder="输入methodName"></el-input>
        </div>
        <div style="width: 100%;">
          <el-input type="textarea" rows="8" resize="none" v-model="testArea" placeholder="输入methodParams,格式示例:{'bright':100}"></el-input>
        </div>
        <div class="footer">
          <el-button type="primary" round @click="testConfirm">{{$t('ctco4')}}</el-button>
        </div>
      </div>
    </form-dialog>
    <!-- <form-dialog :title="$t('terminal.batchAdd')" :dialogVisible="multipleAddDataDialog" @closeDialog="closeMultiAddDialog" dWidth="720px">
      <el-table :data="multipleAddData" style="width: 100%;" height="450" v-loading="multiLoadint">
        <el-table-column prop="device" :label="$t('terminal.name')" width="180"></el-table-column>
        <el-table-column prop="group" label="组织结构" width="180">
        </el-table-column>
        <el-table-column prop="resolution" :label="$t('terminal.resolution')" width="180">
          <template>1920*1080</template>
        </el-table-column>
        <el-table-column prop="sn" label="SN" width="180"></el-table-column>
        <el-table-column prop="name" :label="$t('terminal.structure')" width="180"></el-table-column>
      </el-table>
      <div class="dialog-footer">
        <div class="footer-bt-group">
          <el-button round @click="addMultiDeviceCancel">{{$t('terminal.cancel')}}</el-button>
          <el-button type="primary" round @click="addMultiDevice">{{$t('terminal.confirm')}}</el-button>
        </div>
      </div>
    </form-dialog> -->
    <form-dialog :title="$t('terminal.batchAdd')" :dialogVisible="multipleAddDataDialog" @closeDialog="closeMultiAddDialog" dWidth="720px">
      <div v-loading="addDeviceLoading" :element-loading-text="$t('ctco5')">
        <el-table :data="multipleAddData" style="width: 100%;" height="450" v-loading="multiLoadint">
          <el-table-column prop="device" :label="$t('terminal.name')" width="180"></el-table-column>
          <!-- <el-table-column prop="group" label="组织结构" width="180">
          </el-table-column>-->
          <el-table-column prop="resolution" :label="$t('terminal.resolution')" width="180">
            <template>1920*1080</template>
          </el-table-column>
          <el-table-column prop="sn" label="SN" width="180"></el-table-column>
          <el-table-column prop="name" :label="$t('terminal.structure')" width="180" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="dialog-footer">
          <div class="footer-bt-group">
            <el-upload action accept=".xlsx, .xls" :http-request="getExcel" :show-file-list="false" style="display: inline-block;margin-right: 10px;background-color: transparent;">
              <el-button type="success" round>{{$t('ctco6')}}</el-button>
            </el-upload>
            <el-button round @click="closeMultiAddDialog">{{$t('terminal.cancel')}}</el-button>
            <el-button type="primary" round @click="addMultiDevice" :disabled="excelDeviceList.length==0">{{$t('terminal.confirm')}}</el-button>
            <a href="/static/template.xlsx" download="设备导入模板.xlsx">{{$t('ctco7')}}</a>
          </div>
        </div>
      </div>
    </form-dialog>
  </div>
</template>

<script>
// const OrderGroup = [{
//   id: '1',
//   btType: "danger",
//   orderName: "terminal.reboot",
//   orderType: 'restart_control'
// }, {
//   id: '2',
//   btType: "danger",
//   orderName: "terminal.offscreen",
//   orderType: 'offscreen_control'
// }, {
//   id: '3',
//   btType: "success",
//   orderName: "terminal.onscreen",
//   orderType: 'onscreen_control'
// },
// {
//   id: '4',
//   btType: "primary",
//   orderName: 'terminal.timeTask',
//   orderType: "schedule_setting"
// },
// {
//   id: '5',
//   btType: 'primary',
//   orderName: 'terminal.conBright',
//   orderType: 'setting/bright'
// },
// {
//   id: '6',
//   btType: 'primary',
//   orderName: 'terminal.conVoice',
//   orderType: 'setting/voice'
// },
// {
//   id: '7',
//   btType: 'primary',
//   orderName: 'terminal.relay',
//   orderType: 'relay_control'
// },
// {
//   id: '8',
//   btType: "primary",
//   orderName: 'terminal.timeZone',
//   orderType: "time_zone_setting"
// },
// {
//   id: '9',
//   btType: "primary",
//   orderName: 'terminal.signalChange',
//   orderType: "signal_change"
// },
// {
//   id: '10',
//   btType: 'primary',
//   orderName: 'terminal.synScreen',
//   orderType: 'sync_play'
// },
// {
//   id: '11',
//   btType: 'primary',
//   orderName: 'terminal.timePlay',
//   orderType: 'schedule_running'
// },
// {
//   id: '12',
//   btType: 'primary',
//   orderName: 'terminal.timeOn',
//   orderType: 'power_onoff'
// },
// {
//   id: '13',
//   btType: "primary",
//   orderName: "terminal.batchUpdate",
//   orderType: "batch_update"
// },
// {
//   id: '14',
//   btType: "primary",
//   orderName: "截屏",
//   orderType: "capture_save"
// },
// {
//   id: '15',
//   btType: "primary",
//   orderName: "云看护",
//   orderType: "set_cloud_monitor_time"
// },
// {
//   id: '16',
//   btType: "primary",
//   orderName: "上传日志",
//   orderType: "up_logs"
// },
// {
//   id: '17',
//   btType: "primary",
//   orderName: "紧急信息",
//   orderType: "send_text_info"
// }
// ];
import OrderGroup from '@static/data/contentBtnList.js';
import superClone from '@/assets/scripts/superClone.js';
const delete_url = "/admin/device/del";
//import XLSX from 'xlsx';
import XLSX from 'js-xlsx';
import DeviceMap from "./children/DeviceMap"
import resolutionList from "@static/data/resolution";
import {
  mPagination
} from "@/components/basics/mixins";
import {
  runStateInfo
} from "@/assets/scripts/runState";
import {
  changeDeviceStateName
} from "@/assets/scripts/changeDeviceStateName";
import {
  getDeviceInfo
} from "@/assets/scripts/getDeviceInfo";
import {
  superDeepClone
} from "@/assets/scripts/clone";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";
import {
  sendCommandKp
} from "@/assets/scripts/publicFunction.js";
import DeviceDetailOpen from "./children/DeviceDetailOpen"
import FormDialog from "@/components/basics/FormDialogConfirm";
import Popovers from "@/components/basics/Popover";
import Subfield from "@/components/basics/Subfield";
import trees from "@/components/basics/Trees";
import EnfoldUcd from "@/components/basics/EnfoldUCD";
import pagination from "@/components/basics/Pagination";
//import amapSingleDevice from "@/components/amap/amapSingleDevice";
import DeviceDetail from "./children/DeviceDetail";
import TerminalItem from "./children/TerminalItem";
import OrderFeedBack from "./children/OrderFeedBack";
import HandleOrder from "./children/HandleOrder";
import DelDialog from "@/components/basics/DelDialogConfirm";
import OnlineDetail from "./children/OnlineDetail";
import DeviceDetailHight from "./children/DeviceDetailHight/index.vue";
export default {
  name: 'Control',
  mixins: [mPagination],
  components: {
    Subfield,
    trees,
    EnfoldUcd,
    Popovers,
    pagination,
    FormDialog,
    //"amap-single": amapSingleDevice,
    DeviceDetail,
    DeviceDetailOpen,
    TerminalItem,
    OrderFeedBack,
    HandleOrder,
    DelDialog,
    OnlineDetail,
    DeviceMap,
    DeviceDetailHight
  },
  data() {
    return {
      groupList: [],
      currentModel: 'list',
      MulDelDialogVisible: false,
      testDialog: false,
      multipleAddDataDialog: false,
      multiLoadint: false,
      testInput: '',
      testArea: '',
      detailDialog: false,
      isDetailOnline: false,
      ADDEDIT: '',
      formData: null,
      isList: true,
      isBigMap: false,
      OrderGroup: superClone(OrderGroup),
      configList: {},
      groupIdLabel: [],
      isDetail: false,
      isLoadSingleDevice: false,
      multipleAddData: [],
      fileList: [],
      form: {
        id: "",
        name: "device_" + new Date().getTime(),
        group_id: Number(this.$cookies.get("group_id")), //线下
        //group_id:this.$cookies.get("group_id"),
        type_id: 1, //线下
        //type_id: '2',
        size_id: "",
        attr_id: "1",
        sn: "",
        secret: "",
        remark1: "",
        remark2: "",
        lat: "",
        lng: "",
        kommander_server_name: "",
        ks_id: "",
        w: undefined,
        h: undefined,
        x: 0,
        y: 0,
        ks_run_state: "1",
        installation: new Date(),
      },
      rules: {
        // 表单验证
        name: [{
          required: true,
          message: this.$t('terminal.deviceTip'),
          trigger: 'blur'
        }],
        group_id: [{
          required: true,
          message: this.$t('terminal.groupTips'),
          trigger: 'change'
        }],
        sn: [{
          required: true,
          message: this.$t('terminal.snTip'),
          trigger: 'blur'
        }, {
          required: true,
          message: this.$t('terminal.snTipLan'),
          pattern: /^[0-9A-Z]+$/,
          trigger: 'blur'
        }],
        kommander_server_name: [{
          required: true,
          message: this.$t('terminal.snTip'),
          trigger: 'blur'
        }],
        size_id: [{
          required: true,
          message: this.$t('terminal.sizeTip'),
          trigger: 'blur'
        }],
        w: [{
          required: true,
          message: this.$t('terminal.wTip'),
          trigger: 'blur'
        }],
        h: [{
          required: true,
          message: this.$t('terminal.hTip'),
          trigger: 'blur'
        }],
        x: [{
          required: true,
          message: this.$t('terminal.xTip'),
          trigger: 'blur'
        }],
        y: [{
          required: true,
          message: this.$t('terminal.yTip'),
          trigger: 'blur'
        }]
      },
      edit_device: 0,
      isOpenDetail: false,
      isClearMaInter: false,
      current: 0,
      currentPage: 1,
      currentDetail: {},
      testCount: 0,
      currentDetailVsersion: '',
      currentDeleteDevice: null,
      DelDialogVisible: false,
      feedback: [],
      cap_devices_info: [],
      listSeletList: [],
      terminalList: [],
      currentTableSelect: [],
      selectDatas: [],
      noCheckList: [],
      itemLimit: 12,
      interItem: null,
      cardRefreshTime: 60,
      deviceDialogVisible: false,
      addDeviceLoading: false,
      showMap: false,
      isAnimate: false,
      listShow: true,
      switchNav: false,
      checked: false,
      itemChecked: false, //card的checkbox
      itemAllChecked: false,
      itemsDataList: [],
      itemsNoselect: [],
      itemsCurrentSelect: [],
      itemsNoselectList: [],
      panduan: false, //是否跨页全选
      itemPanduan: false,
      isIndeterminate: false,
      itemCurrentPage: 1,
      itemCurrentPageIsIndeterminate: false,
      itemAllPageIsIndeterminate: false,
      loading: false,
      online: 0,
      offline: 0,
      terminalCount: 0,
      devicelist: [],
      isDeviceLoaded: false,
      btstyle: false,
      search_data: '',
      currentItem: 0,
      itemsData: [],
      excelDeviceList: [],
      imgloading: false,
      Address: {
        pos: '',
        add: ''
      },
      checkedList: [],
      checkedListTime: null,
      deviceType: { 'Pandora': "播放终端", 'Kommander': "直播服务器" },
    }
  },
  mounted() {
    const list = this.$cookies.get('controlButton').split(",");
    this.OrderGroup.forEach(item => {
      if (list.indexOf(item.id) !== -1) {
        item.isFold = true;
      }
    });
  },
  methods: {
    getGroupList() {
      this.$http.post("/admin/access/groupList", {}, (data) => {
        this.groupList = data;
      });
    },
    resetSelectOptions(data, str = "", arr = []) {
      str += "\u00a0\u00a0";
      for (var i = 0; i < data.length; i++) {
        let obj = data[i];
        if (obj.child) {
          obj.name = str + obj.name;
          arr.push(data[i]);
          this.resetSelectOptions(obj.child, str, arr);
        }
      }
      return arr;
    },
    controlMap() {
      this.isBigMap = !this.isBigMap;
    },
    getConfigList(isEdit = false) {
      this.$http.post("/admin/device/configList", {
        flag: 0
      }, data => {
        this.configList = data;
        !isEdit && this.configList.type.forEach(ele => {
          ele.remark_zh = this.deviceType[ele.remark];
          (ele.is_default === 1) && (this.form.type_id = ele.id);
        });

        this.configList.type.forEach(ele => { ele.remark_zh = this.deviceType[ele.remark]; });

        this.groupIdLabel = this.resetSelectOptions(superDeepClone(this.configList.group));
        let size_remark_list = JSON.parse(localStorage.getItem("resolutionList"));
        if (size_remark_list != null) {
          for (let i = 0; i < size_remark_list.length; i++) {
            let flag = 0;
            for (let j = 0; j < resolutionList.length; j++) {
              if (size_remark_list[i].resolution == resolutionList[j].resolution) {
                flag = 1;
                break;
              }
            }
            if (flag == 0) {
              resolutionList.push(size_remark_list[i]);
            }
          }
          this.configList.size = resolutionList;
          // this.form.size_id = resolutionList[resolutionList.length - 1].resolution;
          // console.log(typeof (this.form.size_id))
        } else {
          this.configList.size = resolutionList;
        }
        // if (localStorage.getItem('least_select_size') == null) {
        //   this.form.size_id = resolutionList[resolutionList.length - 1].resolution;
        // } else {
        //   this.form.size_id = localStorage.getItem('least_select_size');
        // }
      });

    },
    amapData(value) {
      if (value.citycode) {
        this.form.lng = value.position[0];
        this.form.lat = value.position[1];
        this.form.citycode = value.citycode;
        this.form.adcode = value.adcode;
        this.form.formattedAddress = value.address;
        this.geocoderLoading = false;
      } else {
        this.geocoderLoading = true;
      }
    },
    changeSizeList() {
      this.form.size_id = ''
    },
    async submitForm() {
      console.log(this.form);
      if (this.form.size_id == -1) {
        this.form.size_id = `${this.form.w}x${this.form.h}`;
        this.configList.size.push({
          id: this.configList.size.length - 1,
          resolution: this.form.size_id
        })
        localStorage.setItem("resolutionList", JSON.stringify(this.configList.size));
      }
      this.form.size_remark = this.form.size_id;

      this.$refs["userForm"].validate((valid) => {
        valid && (this.form.installation = this.form.installation.getTime());
        if (valid && this.ADDEDIT === "ADD") {
          this.$http.post("/admin/device/add", this.form, data => {
            if (data.device_id) {
              this.refreshTerminal();
              this.deviceDialogVisible = false;
              this.showMap = false;
            }
          })

        } else if (valid && this.ADDEDIT === "EDIT") {
          this.form.attr_id = 1;
          this.form.x = 0;
          this.form.y = 0;
          this.$http.post("/admin/device/edit", this.form, () => {
            this.refreshTerminal();
            this.deviceDialogVisible = false;
            this.showMap = false;
          })

        } else {
          if (this.isBigMap) {
            this.$msg({
              type: 'warning',
              message: this.$t('terminal.mapTip')
            })
          }
          return false;
        }
        localStorage.setItem('least_select_size', this.form.size_remark)
      });
    },
    cancel() {
      this.deviceDialogVisible = false;
      this.showMap = false;
    },
    async getAssets(ids) {
      if (ids.type === 'CHECK_GROUP') {
        // this.checkedList = ids.check;
        this.getDeviceList(ids.check);
        return;
      }
      this.isClearMaInter = true;
      this.groupIds = ids.ids;
      this.page = 1;
      if (this.isList) {

        // this.listSeletList = [];
        this.checked = false;
        this.$refs.multipleTable.clearSelection();
        this.panduan = false;

        await this.getTerminalList({
          page: this.page,
          group_ids: this.groupIds,
          limit: this.limit,
          key_word: this.search_data,
        });
      } else {
        this.cap_devices_info = []
        await this.getStatusListItem();
      }
      if (this.currentModel == 'map') {
        await this.getMapListByGroup();
      }

      this.initTerminalCheckBox(this.checkedList, this.terminalList);
    },
    getRowKey(row) {
      return row.id;
    },
    seleceDevice(val) {
      this.isList = true;
      this.panduan = false;
      this.listSeletList = val;
    },
    showAddress(pos, add) {
      this.Address.pos = pos;
      this.Address.add = add;
      //console.log('Address',this.Address)
    },
    closeOpenDetail() {
      this.isOpenDetail = false;
      this.currentDetail = {};
      this.isDetail = false;
      this.listShow = true;
      this.switchNav = false;
      this.isAnimate = true;
      this.listSeletList = [];
      this.noCheckList = [];
    },
    openDetail(row) {
      if (!this.panduan) {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
      this.switchNav = true;
      this.listShow = false;
      this.currentDetail = row;
      this.isDetail = true;
      this.currentDetailVsersion = this.currentDetail.system_version ? this.currentDetail.system_version.split('-')[1] : 260;
    },
    closeDetail() {
      this.isDetail = false;
      this.switchNav = false;
      this.currentDetail = {};
    },
    closeGroup(val) {
      // if (val == true) {
      // 	this.isDetail = false;
      // 	this.listShow = true;
      // 	this.currentDetail = {};
      // }else{
      // 	this.isDetail = false;
      // 	this.switchNav = false;
      // }
      this.isDetail = false;
      this.listShow = true;
      this.switchNav = false;
      this.currentDetail = {};
      console.log(val)
    },
    testCommand() {
      this.testCount += 1;
      if (this.testCount >= 10) {
        this.testDialog = true;
      } else {
        setTimeout(() => {
          this.testCount = 0;
        }, 10000)
      }
    },
    testClose() {
      this.testCount = 0;
      this.testDialog = false;
      this.testArea = "";
    },
    async testConfirm() {
      if (!JSON.parse(this.testArea)) {
        this.$msg({
          type: 'warning',
          message: '请检查格式'
        })
      } else {
        let [device_select_mode, devices_info] = getDeviceInfo(this.isList, this.panduan, this.noCheckList,
          this.listSeletList, this.itemPanduan, this.itemsNoselectList, this.itemsDataList);
        let res = await sendCommandKp(device_select_mode, devices_info, 'set', {
          methodName: this.testInput,
          methodParams: JSON.parse(this.testArea)
        });
        (res && res.result.length > 0) && (this.testDialog = false);
        console.log(res);
      }
    },
    changeCurretModel(model) {
      this.currentModel = model;
      if (this.currentModel != 'list') {
        this.switchNav = false;
        this.listShow = true;
        this.isDetail = false;
        this.currentDetail = {};
      }
      if (this.currentModel == 'card') {
        this.isList = false;
        this.itemCurrentPage = 1;
        this.isLoadSingleDevice = true;
        this.$nextTick(() => {
          let cardWidth = document.getElementById('card').offsetWidth;
          let cardHeight = document.getElementById('card').offsetHeight;
          let row = parseInt(cardWidth / 240);
          let col = parseInt(cardHeight / 213) + 1;
          this.itemLimit = row * col;
          this.isClearMaInter = false;
          this.getTerminalListItem({
            page: 1,
            group_ids: this.groupIds,
            limit: this.itemLimit,
            key_word: this.search_data,
          });
        })
      } else if (this.currentModel == 'list') {
        this.currentPage = 1
        this.isList = true;
        this.listSeletList = [];
        this.noCheckList = [];
        this.panduan = false;
        this.itemsNoselect = [];
        this.itemsCurrentSelect = [];
        this.itemsDataList = [];
        this.itemPanduan = false;
        this.itemChecked = false; //card的checkbox
        this.itemAllChecked = false,
          this.itemsNoselectList = [],
          this.itemSelectCount = 0;
      } else if (this.currentModel == 'map') {
        this.getMapList();
      }
    },
    async getMapListByGroup() {
      this.isDeviceLoaded = false;
      let count = -1;
      let list = [];
      let forNumber = count;
      this.$http.post('/admin/device/list', {
        page: 1,
        group_ids: this.groupIds,
        limit: 50
      }, data => {
        count = data.count ? data.count : -1;
        list = data.list ? data.list : [];
        forNumber = parseInt(count / 50) + 1;
        if (count > 50) {
          for (let i = 2; i <= forNumber; i++) {
            this.$http.post('/admin/device/list', {
              page: i,
              group_ids: this.groupIds,
              limit: 50
            }, data => {
              list = data.list ? list.concat(data.list) : [];
            })
          }
          console.log(list, count)
          let inte = setInterval(() => {
            if (list.length == count) {
              this.devicelist = list;
              this.isDeviceLoaded = true;
              clearInterval(inte);
              inte = null;
            }
          }, 100)
        } else {
          this.devicelist = list;
          this.isDeviceLoaded = true;
        }
      })
    },
    testMap() {
      this.$http.post('/admin/device/list', {
        group_ids: this.groupIds,
        isAmap: true
      })
    },
    getMapList() {
      this.devicelist = [];
      this.isDeviceLoaded = false;
      let num = parseInt(this.terminalCount / 50) + 1;
      for (let i = 1; i <= num; i++) {
        this.$http.post('/admin/device/list', {
          page: i,
          group_ids: this.groupIds,
          limit: 50,
          //isAmap:true
        }, data => {
          this.devicelist = this.devicelist.concat(data.list);
          console.log(this.devicelist.length);
        })
      }
      let inte = setInterval(() => {
        if (this.devicelist.length == this.terminalCount) {
          this.isDeviceLoaded = true;
          clearInterval(inte);
          inte = null;
        }
      })
    },
    openDetailDialog() {
      this.isDetailOnline = true;
      this.detailDialog = true;
    },
    detailCloseDialog() {
      this.detailDialog = false;
      this.isDetailOnline = false;
    },
    async getTerminalList(log) {
      this.loading = true;
      await this.$http.post("/admin/device/list", log, (data) => {
        this.current = parseInt(data.count);
        this.terminalList = data.list ? data.list : [];
        this.loading = false;
        this.online = (data.count_ol == undefined ? 0 : data.count_ol);
        this.offline = (data.count == undefined ? 0 : data.count) - this.online;
        this.terminalCount = data.count;
        this.terminalList.forEach((ele) => {
          ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
          ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
        });
        if (this.panduan == true) {
          for (let i = 0; i < this.terminalList.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.noCheckList.length; j++) {
              if (this.terminalList[i].id === this.noCheckList[j].id) {
                this.$nextTick(() => {
                  this.$refs.multipleTable.toggleRowSelection(
                    this.terminalList[i],
                    false
                  );
                });
                this.$forceUpdate();
                flag = 1;
              }
            }
            if (flag == 0) {
              //console.log(111111111111111);
              this.$refs.multipleTable.toggleRowSelection(
                this.terminalList[i],
                true
              );
              this.$forceUpdate();
            }
          }
        }
      });
    },
    itemSendCaputerCommand() {
      this.$http.post("/admin/command/capture", {
        command: "capture",
        devices_info: uriEncode(this.cap_devices_info),
      });
    },
    async getCaputerImg() {
      //console.log('itemsData',this.itemsData);
      this.imgloading = true;
      this.itemsData.forEach(ele => {
        ele.imgloading = true;
        this.$forceUpdate()
      })
      //this.isClearMaInter = false;
      await this.itemSendCaputerCommand();
      let imgs = document.querySelectorAll(".itemsimg");
      let imgsHight = document.querySelectorAll(".itemsimgHight")
      let imageArr = new Array(imgs.length);
      for (let i = 0; i < imageArr.length; i++) {
        imageArr[i] = new Image();
      }
      let timeInter = new Array(imgs.length);
      let then = this;
      for (let i = 0; i < timeInter.length; i++) {
        clearInterval(timeInter[i]);
        timeInter[i] = null;
      }

      function myInter(i, url) {
        timeInter[i] = setInterval(function () {
          imageArr[i].src = url;
          if (then.isClearMaInter === true) {
            for (let i = 0; i < timeInter.length; i++) {
              clearInterval(timeInter[i]);
              timeInter[i] = null;
            }
            timeInter = null;
          }
        }, 1000);
      }
      let promise1 = (i, url) => {
        return new Promise((resolve) => {
          myInter(i, url);
          imageArr[i].onload = () => {
            imgs[i].src = imgs[i].getAttribute("data-src");
            this.imgloading = false;
            clearInterval(timeInter[i]);
            timeInter[i] = null;
            resolve('ok');
          }
          this.$forceUpdate();
        })
      };
      this.$nextTick(() => {
        for (let i = 0; i < imgs.length; i++) {
          promise1(i, imgs[i].getAttribute("data-src"));
        }
      });
      this.$once('hook:beforeDestroy', () => { //
        if (timeInter) {
          for (let i = 0; i < timeInter.length; i++) {
            clearInterval(timeInter[i]);
            timeInter[i] = null;
          }
          timeInter = null;
        }
      });
      this.myWebSocket.onmessage = (val) => {
        let data = JSON.parse(val.data);
        imgsHight.forEach(ele => {
          if (ele.getAttribute("device-id") == data.pandora_id) {
            ele.src = ele.getAttribute("data-src")
          }
        })
        this.itemsData.forEach(ele => {
          if (ele.id == data.pandora_id) {
            ele.imgloading = false;
            this.$forceUpdate()
          }
        })
      }
    },
    async getTerminalListItem(log) {
      //缩率图时请求数据
      this.loading = true;
      this.cap_devices_info = [];
      await this.$http.post("/admin/device/list", log, (data) => {
        this.currentItem = parseInt(data.count);
        this.itemsData = data.list ? data.list : [];
        this.loading = false;
        //this.terminalCount = data.count;
        this.online = (data.count_ol == undefined ? 0 : data.count_ol);
        this.offline = (data.count == undefined ? 0 : data.count) - this.online;
        this.itemsData.forEach((ele) => {
          ele.isChecked = false;
          ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
          ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
          ele.imgloading = true;
          if (ele.run_state && ele.type_id !== 2) {
            this.cap_devices_info.push({
              id: ele.id,
              sn: ele.sn,
              type_id: ele.type_id,
            });
          }
        });
      });
      this.$nextTick(() => {
        this.getCaputerImg();
      })
    },
    selectionLineChangeHandle(val) {
      let set1 = new Set(val);
      let set2 = new Set(this.currentTableSelect);
      let subset = []; //利用差集记录每次变化的数据 选择或者取消选择
      let noCheck = [];
      if (this.currentTableSelect.length > val.length) {
        for (let item of set2) {
          if (!set1.has(item)) {
            subset.push(item);
          }
        }
      } else {
        for (let item of set1) {
          if (!set2.has(item)) {
            subset.push(item);
          }
        }
      }
      if (this.checked == true) {
        if (this.currentTableSelect.length > val.length) {
          for (let item of set2) {
            if (!set1.has(item)) {
              noCheck.push(item);
            }
          }
          for (let item of set2) {
            if (!set1.has(item)) {
              if (this.noCheckList.indexOf(item) != -1) {
                this.noCheckList.splice(this.noCheckList.indexOf(item), 1);
              }
            }
          }
        } else {
          for (let item of set1) {
            if (!set2.has(item)) {
              for (let i = 0; i < this.noCheckList.length; i++) {
                if (item.id == this.noCheckList[i].id) {
                  this.noCheckList.splice(i, 1);
                }
              }
            }
          }
        }
      }
      for (let i = 0; i < noCheck.length; i++) {
        let flag = 0;
        for (let j = 0; j < this.noCheckList.length; j++) {
          if (noCheck[i].id == this.noCheckList[j].id) {
            flag = 1;
            break;
          }
        }
        if (flag == 0) {
          this.noCheckList.push(noCheck[i]);
        }
      }
      for (let i = 0; i < subset.length; i++) {
        let flag = 0;
        for (let j = 0; j < this.selectDatas.length; j++) {
          if (subset[i].id == this.selectDatas[j].id) {
            flag = 1;
            this.selectDatas.splice(j, 1);
            break;
          }
        }
        if (flag == 0) {
          this.selectDatas.push(subset[i]);
        }
      }
      this.currentTableSelect = val;
      this.listSeletList = val;
      // console.log(this.currentTableSelect);
      // console.log(this.listSeletList);
    },
    openBt() {
      this.btstyle = !this.btstyle;
    },
    orderBack(feedback, isOver) {
      this.feedback = feedback;
      console.log(isOver)
      if (isOver) {
        this.refreshTerminal();
      }
    },
    search() {
      this.currentPage = 1;
      if (this.currentModel == 'list') {
        this.getTerminalList({
          page: 1,
          group_ids: this.groupIds,
          limit: this.limit,
          key_word: this.search_data,
        });
      } else if (this.currentModel == 'card') {
        this.getTerminalListItem({
          page: 1,
          group_ids: this.groupIds,
          limit: this.itemLimit,
          key_word: this.search_data,
        });
      }
    },
    currentChange(val) {
      this.currentPage = val;
      this.loading = true;
      this.page = val;
      this.getTerminalList({
        page: this.page,
        group_ids: this.groupIds,
        limit: this.limit,
        key_word: this.search_data,
      });
    },
    async getStatusListItem(
      list = {
        group_ids: this.groupIds,
        limit: this.itemLimit,
        page: this.itemCurrentPage,
        ds_w: this.refW,
        run_state: this.rState,
      }
    ) {
      this.loading = true;
      this.itemsCurrentSelect = [];
      await this.$http.post("/admin/device/list", list, (data) => {
        this.itemsData = data.list ? data.list : [];
        this.currentItem = parseInt(data.count); //获取数据的总条数
        this.loading = false;
        this.online = (data.count_ol == undefined ? 0 : data.count_ol);
        this.offline = (data.count == undefined ? 0 : data.count) - this.online;
        this.itemsData.forEach((ele) => {
          ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
          ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
          if (ele.run_state && ele.type_id !== 2) {
            this.cap_devices_info.push({
              id: ele.id,
              sn: ele.sn,
              type_id: ele.type_id,
            });
          }
          //ele.isChecked = false;
        });
        if (this.itemPanduan == true) {
          for (let i = 0; i < this.itemsData.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.itemsNoselectList.length; j++) {
              if (this.itemsData[i].id == this.itemsNoselectList[j].id) {
                this.itemsData[i].isChecked = false;
                this.itemsCurrentSelect.splice(i, 1);
                flag = 1;
              }
            }
            if (flag == 0) {
              this.itemsData[i].isChecked = true;
              this.itemsCurrentSelect.push(this.itemsData[i]);
            }
          }
          this.$forceUpdate();
        } else {
          this.itemsData.forEach((ele) => {
            ele.isChecked = false;
          });
          this.$forceUpdate();
        }
        if (this.itemPanduan == false) {
          for (let i = 0; i < this.itemsData.length; i++) {
            for (let j = 0; j < this.itemsDataList.length; j++) {
              if (this.itemsData[i].id == this.itemsDataList[j].id) {
                this.itemsData[i].isChecked = true;
                if (this.itemsCurrentSelect.indexOf(this.itemsData[i]) == -1) {
                  this.itemsCurrentSelect.push(this.itemsData[i]);
                }
                this.$forceUpdate();
              }
            }
          }
        }
      });
      this.$nextTick(() => {
        this.isClearMaInter = false;
        this.getCaputerImg();
      })
    },
    currentChangeItem(val) {
      this.isClearMaInter = true;
      this.itemCurrentPage = val;
      this.loading = true;
      this.cardRefreshTime = 60;
      setTimeout(() => {
        this.getStatusListItem();
      }, 1000)
      this.$forceUpdate();
    },
    itemSelectAll() {
      if (this.itemAllChecked == true) {
        //如果先选择了选择全部再点击全选本页下的逻辑判断,只需关心未选择的设备
        if (this.itemChecked == true) {
          //全选本页为true
          this.itemsCurrentSelect.length = this.itemLimit; //??
          for (let i = 0; i < this.itemsData.length; i++) {
            if (this.itemsData[i].isChecked == false) {
              this.itemsData[i].isChecked = true;
              for (let j = 0; j < this.itemsNoselectList.length; j++) {
                if (this.itemsData[i].id == this.itemsNoselectList[j].id) {
                  this.itemsNoselectList.splice(j, 1);
                }
              }
            }
          }
        } else {
          //全选本页为false
          this.itemsCurrentSelect = [];
          for (let i = 0; i < this.itemsData.length; i++) {
            if (this.itemsData[i].isChecked == true) {
              this.itemsData[i].isChecked = false;
              let flag = 0;
              for (let j = 0; j < this.itemsNoselectList.length; j++) {
                if (this.itemsData[i].id == this.itemsNoselectList[j].id) {
                  flag = 1;
                }
              }
              if (flag == 0) {
                this.itemsNoselectList.push(this.itemsData[i]);
              }
            }
          }
        }
      } else {
        //非选择全部下的逻辑判断
        if (this.itemChecked == true) {
          this.itemsData.forEach((ele) => {
            if (ele.isChecked == false) {
              ele.isChecked = true;
              this.itemsDataList.push(ele);
              this.itemsCurrentSelect.push(ele);
            }
          });
        } else {
          for (let i = 0; i < this.itemsDataList.length; i++) {
            for (let j = 0; j < this.itemsCurrentSelect.length; j++) {
              if (this.itemsDataList[i].id == this.itemsCurrentSelect[j].id) {
                this.itemsDataList.splice(i, 1);
              }
            }
          }
          this.itemsCurrentSelect = [];
          this.itemsData.forEach((ele) => {
            ele.isChecked = false;
          });
        }
      }
    },
    itemSelectAllPage() {
      //this.itemAllPageIsIndeterminate = false;
      if (this.itemAllChecked == true) {
        this.itemPanduan = true;
        this.itemsData.forEach((ele) => {
          if (ele.isChecked == false) {
            ele.isChecked = true;
            this.itemsDataList.push(ele);
            this.itemsCurrentSelect.push(ele);
          }
        });
      } else {
        this.itemPanduan = false;
        this.itemsData.forEach((ele) => {
          if (ele.isChecked == true) {
            ele.isChecked = false;
          }
        });
        this.itemsDataList = [];
        this.itemsNoselectList = [];
        this.itemsCurrentSelect = [];
      }
    },
    checkedItem(item) {
      if (item.isChecked == true) {
        this.itemsDataList.push(item); //保存选择的item，翻页的时候将其ischecked置为true
        this.itemsCurrentSelect.push(item); //保存本页选择的数据，用于判断全选本页的状态
      } else {
        this.itemSelectCount -= 1;
        this.itemsNoselect.push(item); //取消选择时保存
        //console.log("删除...", this.itemsDataList.indexOf(item));
        for (let i = 0; i < this.itemsDataList.length; i++) {
          if (item.id == this.itemsDataList[i].id) {
            this.itemsDataList.splice(i, 1);
          }
        }
        //this.itemsDataList.splice(this.itemsDataList.indexOf(item), 1)
        this.itemsCurrentSelect.splice(this.itemsDataList.indexOf(item), 1);
      }
      if (this.itemPanduan == true) {
        //当是选择全部的模式下，需要记录取消选择的设备
        if (item.isChecked == false) {
          //为false则加入未选择的列表
          let flag = 0;
          for (let i = 0; i < this.itemsNoselectList.length; i++) {
            if (item.id == this.itemsNoselectList[i].id) {
              flag = 1;
            }
          }
          if (flag == 0) {
            this.itemsNoselectList.push(item);
          }
        }
        if (item.isChecked == true) {
          //为true则表示重新选择了，需要从未选择列表里面删除
          for (let i = 0; i < this.itemsNoselectList.length; i++) {
            if (this.itemsNoselectList[i].id == item.id) {
              this.itemsNoselectList.splice(i, 1);
            }
          }
        }
      }
      this.$forceUpdate()
    },
    selectItem() {
      //console.log(1111)
    },
    selectAll() {
      //跨页全选
      if (this.checked) {
        this.panduan = true;
        this.terminalList.forEach((ele) => {
          this.$refs.multipleTable.toggleRowSelection(ele,
            true); //这一条语句会自动触发eltable的selectionchange函数
        });
      } else {
        this.$refs.multipleTable.clearSelection();
        this.panduan = false;
      }
    },

    // analysis(file) {
    // 	return new Promise(function(resolve) {
    // 		const reader = new FileReader();
    // 		reader.onload = function(e) {
    // 			const data = e.target.result;
    // 			let datajson = XLSX.read(data, {
    // 				type: "binary"
    // 			});
    // 			const result = [];
    // 			datajson.SheetNames.forEach(sheetName => {
    // 				result.push({
    // 					sheetName: sheetName,
    // 					sheet: XLSX.utils.sheet_to_json(datajson.Sheets[sheetName])
    // 				});
    // 			});
    // 			resolve(result);
    // 		};
    // 		reader.readAsBinaryString(file.file);
    // 	});
    // },
    addDeviceList() {
      this.multipleAddDataDialog = true;
    },

    getExcel(file) {
      // const types = file.file.name.split(".")[1]; //获取文件后缀
      // const fileType = ["xlsx", "xls"].some(
      //   item => item === types
      // );
      // if (!fileType) {
      //   this.$msg({
      //     "type": "warning",
      //     "message": "格式错误！请重新选择"
      //   });
      //   return;
      // }
      // this.readWorkbookFromLocalFile(file)
      let reader = new FileReader();
      reader.onload = async (e) => {
        let data = e.target.result;
        let workbook = XLSX.read(data, { type: 'binary' });
        this.excelDeviceList = XLSX.utils.sheet_to_json(workbook.Sheets.Sheet1);

        this.multipleAddData = this.excelDeviceList.map((d) => {
          const { device, sn } = d;
          let path = [];
          for (let key in d) { Number(key) && path.push(d[key]); }
          return {
            device,
            sn,
            resolution: "1920x1080",
            name: path.join("/")
          }
        });
      }
      reader.readAsBinaryString(file.file);
      // this.multipleAddDataDialog = true;
    },
    async addMultiDevice() {
      let deviceList = this.excelDeviceList;
      // console.log(deviceList);
      this.addDeviceLoading = true;
      await this.$http.post("/admin/access/groupList", {}, data => {
        this.fileList = data;
      })
      for await (let d of deviceList) {
        let path = [];
        for (let key in d) {
          Number(key) && path.push(d[key]);
        }
        await this.autoAddGroup(this.fileList[0], path);
      }
      this.addDeviceLoading = false;

      await this.$http.post("/admin/access/groupList", {}, data => {
        this.fileList = data;
      })
      deviceList = deviceList.map((d) => {
        const { device, sn } = d;
        let path = [];
        for (let key in d) {
          Number(key) && path.push(d[key]);
        }
        let dev = this.getGroupId(this.fileList[0], path);
        return { device, sn, groupId: dev.id, name: dev.name };
      });

      this.dataProcessing(deviceList);
    },

    // async readWorkbookFromLocalFile(e) {
    //   let reader = new FileReader();
    //   reader.onload = async (e) => {
    //     let data = e.target.result;
    //     let workbook = XLSX.read(data, { type: 'binary' });

    //     let deviceList = XLSX.utils.sheet_to_json(workbook.Sheets.Sheet1);

    //     this.addDeviceLoading = true;
    //     await this.$http.post("/admin/access/groupList", {}, data => {
    //       this.fileList = data;
    //     })
    //     for await (let d of deviceList) {
    //       let path = [];
    //       for (let key in d) {
    //         Number(key) && path.push(d[key]);
    //       }
    //       await this.autoAddGroup(this.fileList[0], path);
    //     }
    //     this.addDeviceLoading = false;

    //     await this.$http.post("/admin/access/groupList", {}, data => {
    //       this.fileList = data;
    //     })
    //     deviceList = deviceList.map((d) => {
    //       const { device, sn } = d;
    //       let path = [];
    //       for (let key in d) {
    //         Number(key) && path.push(d[key]);
    //       }
    //       let dev = this.getGroupId(this.fileList[0], path);
    //       // console.log(dev);
    //       return { device, sn, groupId: dev.id, name: dev.name };
    //     });

    //     for (let i = 0; i < deviceList.length; i++) {
    //       const { device, sn, groupId, name } = deviceList[i];
    //       console.log(!(device && sn && groupId && name));
    //       if (!(device && sn && groupId && name)) {
    //         this.$msg({ type: "warning", message: `解析出错,请检查第${i + 1} 条数据` });
    //         return;
    //       }
    //     }

    //     this.multipleAddData = deviceList;
    //     // this.multipleAddDataDialog = true;

    //     // let checkFlag = true;
    //     // let errorIndex = 0;
    //     // this.multipleAddData.forEach((ele, index) => {
    //     //   if (ele.device == undefined || ele.groupId == undefined || ele.name == undefined || ele.sn == undefined) {
    //     //     checkFlag = false;
    //     //     errorIndex = index;
    //     //   }
    //     // })
    //     // checkFlag && (this.multipleAddDataDialog = true);
    //     // console.log(errorIndex);
    //     // // !checkFlag && (this.$msg({ type: "warning", message: `解析出错,请检查第${errorIndex + 1} 条数据` }));
    //     // console.log(deviceList);
    //   };

    //   reader.readAsBinaryString(e.file);
    // },

    async autoAddGroup(list, path) {
      if (path.length === 0) {
        return {};
      }
      const { id: pid } = list;
      let listChile = list.child.find((item) => item.name === path[0]);
      if (!listChile) {
        await this.$http.post("/admin/access/addGroup", { pid, name: path[0] }, res => {
          const { id } = res;
          list.child.push({ pid, id, name: path[0], child: [] });
        });
      }
      listChile = list.child.find((item) => item.name === path[0]);
      path.splice(0, 1);
      return this.autoAddGroup(listChile, path);
    },

    getGroupId(list, path) {
      if (list.child.length === 0 || path.length === 0) {
        return list;
      }
      let listChile = list.child.find((item) => item.name === path[0]);
      if (!listChile) {
        return {};
      }
      path.splice(0, 1)
      return this.getGroupId(listChile, path);
    },

    // addMultiDevice() {
    //   this.multiLoadint = true;
    //   let arr = [];
    //   this.multipleAddData.forEach(ele => {
    dataProcessing(list) {
      this.multiLoadint = true;
      let arr = [];
      list.forEach(ele => {
        arr.push(this.$http.post("/admin/device/add", {
          name: ele.device,
          group_id: ele.groupId,
          type_id: 1,
          size_id: "1920x1080",
          attr_id: 1,
          sn: ele.sn,
          x: 0,
          y: 0,
          ks_run_state: 1,
          size_remark: "1920x1080"
        }))
      })
      Promise.all(arr).then(() => {
        this.multiLoadint = false;
        this.refreshTerminal();
        this.multipleAddDataDialog = false;
        this.$router.go(0);
      })
    },
    // addMultiDeviceCancel() {
    //   this.multipleAddData = [];
    //   this.multipleAddDataDialog = false;
    // },
    closeMultiAddDialog() {
      this.multipleAddData = [];
      this.multipleAddDataDialog = false;
    },



    addMultiDeviceCancel() {
      this.multipleAddData = [];
      this.multipleAddDataDialog = false;
    },
    // closeMultiAddDialog() {
    //   this.multipleAddDataDialog = false;
    // },
    refreshTerminal() {
      if (this.currentModel == 'list') {
        this.getTerminalList({
          page: this.page,
          group_ids: this.groupIds,
          limit: this.limit,
          key_word: this.search_data,
        })
      } else if (this.currentModel == 'card') {
        this.getTerminalListItem({
          page: this.itemCurrentPage,
          group_ids: this.groupIds,
          limit: this.itemLimit,
          key_word: this.search_data,
        });
      }
    },
    addDevice() {
      this.ADDEDIT = 'ADD';
      this.getConfigList();
      this.showMap = true;
      this.isLoadSingleDevice = true;
      this.deviceDialogVisible = true;
    },
    handleDetail(row) {
      this.$http.post("/admin/device/detail", {
        id: row.id
      }, data => {
        sessionStorage.setItem('liveId', data.sn);
      })
      this.currentDetail = row;
      this.isOpenDetail = true;
    },
    handleDelete(row) {
      this.DelDialogVisible = true;
      this.currentDeleteDevice = row;
    },
    handleSort(index) {
      if (index === 0) { return; }
      let list = superClone(this.terminalList);
      const { id: id_1, sort_order: sort_1 } = list[index];
      const { id: id_2, sort_order: sort_2 } = list[index - 1];

      this.$http.post("/admin/device/deviceSort", {
        id_1, id_2, sort_1: sort_1 || id_1, sort_2: sort_2 || id_2,
      }, () => {
        let temp = list[index];
        list[index] = list[index - 1];
        list[index - 1] = temp;
        this.terminalList = list;
      });
    },
    async handleEdit(row) {
      this.ADDEDIT = 'EDIT';
      await this.getConfigList(true);

      await this.$http.post("/admin/device/detail", {
        id: row.id
      }, data => {
        this.form = data;
        this.form.id = row.id;
        this.form.size_id = this.form.size_remark;
        this.form.installation = new Date(parseInt(data.installation));
        this.$set(this.form, 'kommander_server_name', this.form.sn.split("@")[0]);
        this.isLoadSingleDevice = true;
      })
      this.showMap = true;
      this.deviceDialogVisible = true;
    },
    deviceFormDiaoClose() {
      this.deviceDialogVisible = false;
      this.isLoadSingleDevice = false;
      this.showMap = false;
      this.isBigMap = false;
      this.form = {
        id: "",
        name: "device_" + new Date().getTime(),
        group_id: Number(this.$cookies.get("group_id")), //线下
        //group_id:this.$cookies.get("group_id"),
        type_id: 1, //线下
        //type_id: '2',
        size_id: "",
        attr_id: "1",
        sn: "",
        secret: "",
        remark1: "",
        remark2: "",
        lat: "",
        lng: "",
        kommander_server_name: "",
        ks_id: "",
        w: undefined,
        h: undefined,
        x: 0,
        y: 0,
        ks_run_state: "1",
        installation: new Date(),
      }
      this.rules.sn = [{
        required: true,
        message: this.$t('terminal.snTip'),
        trigger: 'blur'
      }, {
        required: true,
        message: this.$t('terminal.snTipLan'),
        pattern: /^[0-9A-Z]+$/,
        trigger: 'blur'
      }];
    },
    changeRule(data) {
      const kommanderSnRules = [{
        required: true,
        message: this.$t('terminal.snTip'),
        trigger: 'blur'
      }];
      const kapolloSnRules = [{
        required: true,
        message: this.$t('terminal.snTip'),
        trigger: 'blur'
      }, {
        required: true,
        message: this.$t('terminal.snTipLan'),
        pattern: /^[0-9A-Z]+$/,
        trigger: 'blur'
      }];
      if (data == 1) {
        this.rules.sn = kapolloSnRules;

      } else {
        this.rules.sn = kommanderSnRules;
      }

    },
    async MulDelDialog(isConfirm) {
      if (isConfirm) {
        let result = getDeviceInfo(this.isList, this.panduan, this.noCheckList, this.listSeletList, this
          .itemPanduan, this.itemsNoselectList, this.itemsDataList);
        if (result) {
          this.$http.post(
            delete_url, {
            device_select_mode: result[0],
            devices_info: uriEncode(result[1]),
            group_ids: this.groupIds
          }, () => {
            this.refreshTerminal();
          })
          this.noCheckList = [];
          this.selectDatas = [];
          this.checked = false;
          this.itemsDataList = [];
          this.itemsCurrentSelect = [];
          this.listSeletList = [];
          this.itemsNoselectList = [];
          this.$refs.multipleTable.clearSelection();
        } else {
          this.$msg({
            type: 'warning',
            message: this.$t('terminal.selectTip')
          })
        }

      }
      this.MulDelDialogVisible = false;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post(
          "/admin/device/del", {
          device_select_mode: "multiple",
          group_ids: sessionStorage.getItem('group_ids'),
          devices_info: uriEncode([{
            id: this.currentDeleteDevice.id,
            sn: this.currentDeleteDevice.sn,
            name: this.currentDeleteDevice.name,
            type_id: this.currentDeleteDevice.type_id,
          },]),
        }, () => {
          this.refreshTerminal();
        }
        );
      }
      this.DelDialogVisible = false;
    },
    multipleDelete() {
      let result = getDeviceInfo(this.isList, this.panduan, this.noCheckList, this.listSeletList, this
        .itemPanduan, this.itemsNoselectList, this.itemsDataList);
      if (result) {
        this.MulDelDialogVisible = true;
      } else {
        this.$msg({
          type: 'warning',
          message: this.$t('terminal.selectTip')
        })
      }

    },
    getDeviceList(group_ids) {
      // console.log(group_ids);
      this.$refs.multipleTable.clearSelection();
      clearTimeout(this.checkedListTime);
      this.checkedListTime = setTimeout(() => {
        if (group_ids.length > 0) {
          this.$http.post("/admin/device/selectList", { device_select_mode: 'all', group_ids: group_ids.join(',') }, (res) => {
            this.checkedList = res;
            this.initTerminalCheckBox(this.checkedList, this.terminalList);
          });
        } else {
          this.checkedList = [];
        }
      }, 10);
    },
    initTerminalCheckBox(checkedList, terminalList) {
      this.$refs.multipleTable.clearSelection();
      checkedList.forEach(row => {
        let dItem = terminalList.find(t => t.id === row.id);
        if (dItem) {
          this.$refs.multipleTable.toggleRowSelection(dItem, true);
        } else {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        }
      });
    }
  },
  created() {
    if (this.$route.params.type === "addTerminal") {
      this.$nextTick(() => {
        setTimeout(() => {
          this.ADDEDIT = "ADD";
          this.edit_device = null;
          this.getConfigList();
          this.deviceDialogVisible = true;
          this.showMap = true;
        }, 500);
      });
    }
    let feedback = sessionStorage.getItem('orderFeedBack') ? JSON.parse(sessionStorage.getItem('orderFeedBack')) :
      [];
    let sizeList = localStorage.getItem('kares_remark_list');
    console.log(sizeList);
    this.feedback = feedback;
    this.getGroupList();
    this.getTerminalList({
      page: 1,
      group_ids: this.groupIds,
      limit: this.limit,
    });
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  watch: {
    currentModel() {
      if (this.currentModel == 'card') {
        this.cardRefreshTime = 60;
        this.interItem = setInterval(() => {
          this.cardRefreshTime -= 1;
          if (this.cardRefreshTime == 0) {
            this.isClearMaInter = true;

            setTimeout(() => {
              this.isClearMaInter = false;
              this.getCaputerImg();
            }, 3000)
            this.cardRefreshTime = 60;
          }
        }, 1000);
      } else {
        this.isClearMaInter = true;
        clearInterval(this.interItem);
      }
    },
    noCheckList() {
      //全选模式下,取消选择的设备
      if (this.panduan == true) {
        console.log('nocheck', this.noCheckList)
        if (this.noCheckList.length > 0 && this.noCheckList.length !== this.current) {
          //this.checked = false;
          this.isIndeterminate = true;
        } else if (this.noCheckList.length !== this.current) {
          this.isIndeterminate = false;
          this.checked = false
        } else {
          this.isIndeterminate = false;
          //this.checked = false;
          //this.panduan = false;
        }
      }
    },
    listSeletList() {
      if (this.panduan == false) {
        if (this.listSeletList.length > 0 && this.listSeletList.length < this.current) {
          this.isIndeterminate = true;
        } else if (this.listSeletList.length == this.current) {
          //console.log("触发.....");
          this.isIndeterminate = false;
          this.checked = true;
        } else if (this.listSeletList.length == 0) {
          this.isIndeterminate = false;
          this.checked = false;
        }
      }
    },
    itemsCurrentSelect() {
      if (this.itemsCurrentSelect.length == this.itemsData.length && this.itemsCurrentSelect.length != 0) {
        this.itemChecked = true;
      } else {
        this.itemChecked = false;
      }
      if (this.itemsCurrentSelect.length < this.itemsData.length && this.itemsCurrentSelect.length > 0) {
        this.itemCurrentPageIsIndeterminate = true;
      } else if (this.itemsCurrentSelect.length == 0 || this.itemsCurrentSelect.length == this.itemsData
        .length) {
        this.itemCurrentPageIsIndeterminate = false;
      }
    },
    itemsDataList() {
      if (this.itemPanduan == false) {
        if (
          this.itemsDataList.length > 0 &&
          this.itemsDataList.length < this.currentItem
        ) {
          this.itemAllPageIsIndeterminate = true;
        } else if (this.itemsDataList.length == this.currentItem) {
          this.itemAllPageIsIndeterminate = false;
          this.itemAllChecked = true;
        }
      } else {

        if (this.itemsNoselectList.length > 0) {
          this.itemAllPageIsIndeterminate = true;
        } else if (this.itemsNoselectList.length == 0) {
          this.itemAllPageIsIndeterminate = false;
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  .cell {
    font-size: 18px;
    color: #2fb3ff;
  }

  th:last-child > .cell {
    text-align: center;
  }
}

.cu1 {
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: #2fb3ff;
    font-size: 16px;
    right: 10px;
  }
}
.dialog-footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  .footer-bt-group {
    width: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    a {
      position: absolute;
      right: -160px;
    }
  }
}
.control {
  width: 100%;
  height: 100%;

  .sub {
    width: 100%;
    height: 100%;

    .icon {
      width: 30px;
      height: 30px;
      margin-right: 15px;
    }

    /deep/ .eu-content {
      position: relative;

      .up {
        padding-top: 10px;
        flex-direction: column;
      }
    }

    .cu0 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .up-right {
        display: flex;
        align-items: center;

        .testDiv {
          width: 30px;
          height: 30px;
        }
      }

      .isonline {
        display: flex;
        align-items: center;
        margin-left: 10px;

        .online_div {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background-color: #19d4ae;
          margin-right: 6px;
          box-shadow: 0px 0px 0px 2px rgba(54, 206, 143, 0.5);

          // .online_div_small {}
        }

        .online_divr {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background-color: #ff4949;
          margin-left: 5px;
          margin-right: 6px;
          box-shadow: 0px 0px 0px 2px rgba(255, 73, 73, 0.5);
        }

        .online {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 3px;
          letter-spacing: 2px;
          color: #19d4ae;
        }

        .offline {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 3px;
          letter-spacing: 2px;
          color: #ff4949;
        }

        .detail {
          font-size: 16px;
          cursor: pointer;
          white-space: nowrap;
        }
      }
    }

    .cu1 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 3px;
      padding-top: 3px;
      .cu1_right {
        display: flex;
        margin-right: 10px;
        justify-content: space-between;

        // span {
        // 	font-size: 16px;
        // }

        div {
          color: white;
          background-color: #35cafa;
          border-radius: 3px;
          width: 80px;

          margin-left: 10px;
          text-align: center;
          cursor: pointer;
        }
      }

      .up-left {
        width: 300px;
        display: flex;
        align-items: center;

        .deg {
          transform: rotateZ(0deg);
          transition: all 200ms;
        }

        .deg90 {
          transform: rotateZ(90deg);
        }

        .search {
          display: flex;
        }
      }
    }

    .cu2 {
      height: 40px;
      width: 100%;
      transition: all 300ms;
      position: relative;
      display: flex;
      align-items: center;
      overflow-x: auto;

      //justify-content: flex-start;
    }

    // .cu2 {

    // 	height: 40px;
    // 	width: 100%;
    // 	position: relative;
    // 	overflow: hidden;
    // 	overflow-x: auto;
    // 	transition: all 300ms;
    // 	.left-bottom {
    // 		display: flex;
    // 		height: 100%;
    // 		position: absolute;
    // 		left: 0;
    // 		margin-bottom: 10px;
    // 		align-items: center;
    // 	}

    // 	.left-bottom div:hover {
    // 		cursor: pointer;
    // 	}
    // }

    .cu2Style0 {
      height: 0;
      overflow: hidden;
    }

    .operation {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .icon {
        margin: 0px;
      }
    }

    .down {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      position: relative;

      .pagina {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .feedback {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
    }
  }

  .form {
    width: 360px;
    max-height: calc(100vh - 320px);
    padding-right: 32px;

    .location_xy {
      display: flex;
    }

    .location_y {
      margin-left: 5px;
    }

    .input-label {
      display: flex;
      justify-content: space-between;

      .el-button {
        margin-left: 0px !important;
      }
    }
  }

  .map {
    width: 436px;
    height: 600px;
    max-height: calc(100vh - 320px);
    max-height: 415px;
    box-sizing: border-box;
    position: relative;

    .controlMap {
      width: 10px;
      position: absolute;
      left: -10px;
      top: calc(50% - 40px);
      transform: translateY(-50%);
      cursor: pointer;
    }

    .controlMapRight {
      transform: rotate(180deg);
    }
  }

  .formClose {
    width: 0;
  }

  .bigMap {
    width: calc(100% - 10px);
  }

  .details {
    height: 100%;
    display: flex;

    .left {
      width: 10px;
      height: 100%;
      background-color: #edfbff;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      position: relative;

      .closeicon {
        width: 10px;
        height: 28px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        transform: rotate(180deg);
        cursor: pointer;
      }
    }

    .right {
      width: calc(100% - 10px);
      background-color: white;
      border-radius: 8px 0px 0px 8px;
    }
  }

  .rightDetail {
    width: 100%;
    height: 100%;
  }

  .card {
    width: 100%;
    height: calc(100% - 10px);
    padding-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .items {
      position: relative;

      .check {
        display: none;
      }

      .ckecked {
        display: block;
      }

      .itemsimg,
      .itemsimgHight {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #000;
      }
    }

    .items:hover .check {
      display: block;
    }

    .itemsblock {
      width: 20%;
      max-width: 240px;
      margin: 4px;
      height: 0;
      box-sizing: border-box;
    }
  }
}

@media screen and (min-width: 1200px) {
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(240, 240, 240, 1);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    box-shadow: inset 0 0 0px rgba(53, 202, 250, 0.3);
    background-color: rgba(53, 202, 250, 0.3);
  }
}
</style>
